<template>
  <div class="promotion-end">
    <div class="prompt">{{prompt}}</div>
  </div>
</template>

<script>
import {i18n} from '@/utils/i18n'

export default {
  name: 'PromotionEnd',
  i18n,
  created () {
    // this.prompt = i18n.t('promotion.end.prompt')
  },
  data () {
    return {
      prompt: '你来晚了，活动已结束'
    }
  }
}
</script>

<style lang="postcss">
.promotion-end {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC;
  font-size: 18px;
  font-weight: 500;
  background-color: #ffffff;
  color: #6ca2ff;
}
</style>
